import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src", "width", "height"]

import type {
  QuestionnaireFormOption,
  QuestionnaireImage,
} from '@/models/onboarding.types'

import OptionRadio from '../OptionRadio.vue'
import OptionText from '../OptionText.vue'
import OptionCheckbox from '../OptionCheckbox.vue'

export type OptionsBodyPageFields = {
  multipleOptions?: boolean
  maxOptions?: number
  centerText?: boolean
  wrapInputs?: boolean
  image?: QuestionnaireImage
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OptionsBody',
  props: /*@__PURE__*/_mergeModels({
    page: {},
    options: {},
    skipOption: {},
    imageSrc: {},
    sampleFirst: { type: Boolean }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["skip"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {



const selectedOptions = _useModel<string[]>(__props, "modelValue")

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["onboarding-options__options", {
        'onboarding-options__options--wrap': __props.page.wrapInputs,
        'onboarding-options-body--20710': __props.sampleFirst,
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (__props.page.multipleOptions)
            ? (_openBlock(), _createBlock(OptionCheckbox, {
                key: `a-${option.label}`,
                modelValue: selectedOptions.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOptions).value = $event)),
                class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': __props.page.centerText }]),
                option: option,
                maxOptions: __props.page.maxOptions
              }, null, 8, ["modelValue", "class", "option", "maxOptions"]))
            : (option.type === 'text-input')
              ? (_openBlock(), _createBlock(OptionText, {
                  key: `b-${option.label}`,
                  modelValue: selectedOptions.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOptions).value = $event)),
                  class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': __props.page.centerText }]),
                  option: option
                }, null, 8, ["modelValue", "class", "option"]))
              : (_openBlock(), _createBlock(OptionRadio, {
                  key: `c-${option.label}`,
                  modelValue: selectedOptions.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOptions).value = $event)),
                  class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': __props.page.centerText }]),
                  option: option
                }, null, 8, ["modelValue", "class", "option"]))
        ], 64))
      }), 256))
    ], 2),
    (__props.skipOption)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "onboarding-options__option-skip",
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('skip')))
        }, _toDisplayString(__props.skipOption.label), 1))
      : _createCommentVNode("", true),
    (__props.page.image && __props.imageSrc)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "onboarding-options__image",
          src: __props.imageSrc,
          width: __props.page.image.width,
          height: __props.page.image.height,
          alt: ""
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})